export const BILLING_ADDRESS_FIELDS = ['address_ln_1', 'address_ln_2', 'city', 'state', 'zip'];

export const CHARGE_METHODS = {
  NEW_CARD: 'credit-card',
  STORED_CARD: 'saved-cards',
  RECURRING: 'recurring-charge'
};

export const PAYROC_FORM_ID = 'pre-auth-modal';

export const hasPendingCharge = (values) =>
  Number(values?.amount) > 0 &&
  (values?.method === CHARGE_METHODS.NEW_CARD || values?.method === CHARGE_METHODS.STORED_CARD);

export const PRE_AUTH_NARROW_BREAKPOINT = 1024;
